var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2, _class2, _temp4, _class3, _temp5;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import idx from 'idx';
import { STATES } from './statechart';

var _React$createContext = React.createContext({
  data: {},
  globalCacheProvider: null,
  setContextCache: function setContextCache() {},
  setResponse: function setResponse() {}
}),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

var LoadsProvider = (_temp2 = _class = function (_React$Component) {
  _inherits(LoadsProvider, _React$Component);

  function LoadsProvider() {
    var _temp, _this, _ret;

    _classCallCheck(this, LoadsProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContextCache = function (key, value) {
      _this.setState(function (prevState) {
        var _extends2;

        return {
          data: _extends({}, prevState.data, (_extends2 = {}, _extends2[key] = value, _extends2))
        };
      });
    }, _this.setResponse = function (params) {
      var globalCacheProvider = _this.props.cacheProvider;
      var contextKey = params.contextKey,
          localCacheProvider = params.cacheProvider,
          _params$data = params.data,
          error = _params$data.error,
          response = _params$data.response,
          state = _params$data.state;

      if (!contextKey) return;
      var cacheProvider = localCacheProvider || globalCacheProvider;
      var value = _extends({}, state === STATES.SUCCESS ? { response: response } : {}, state === STATES.ERROR ? { error: error } : {}, {
        state: state
      });
      if (cacheProvider && cacheProvider.set) {
        cacheProvider.set(contextKey, value);
      }
      _this.setContextCache(contextKey, value);
    }, _this.state = {
      data: {},
      globalCacheProvider: _this.props.cacheProvider,
      setContextCache: _this.setContextCache,
      setResponse: _this.setResponse
    }, _this.render = function () {
      var children = _this.props.children;

      return React.createElement(
        Provider,
        { value: _this.state },
        children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LoadsProvider;
}(React.Component), _class.defaultProps = {
  cacheProvider: null
}, _temp2);
LoadsProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  cacheProvider: PropTypes.shape({
    get: PropTypes.func,
    set: PropTypes.func
  })
} : {};
var LoadsConsumer = (_temp4 = _class2 = function (_React$Component2) {
  _inherits(LoadsConsumer, _React$Component2);

  function LoadsConsumer() {
    var _temp3, _this2, _ret2;

    _classCallCheck(this, LoadsConsumer);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.state = {
      contextKey: null,
      cacheProviderData: {},
      cacheProvider: _this2.props.cacheProvider || idx(_this2.props, function (_) {
        return _.context.globalCacheProvider;
      }),
      hasLoaded: false
    }, _this2.componentDidMount = function () {
      _this2.getCachedResponseFromCacheProvider();
    }, _this2.componentDidUpdate = function (prevProps) {
      var prevContextKey = prevProps.contextKey;
      var contextKey = _this2.props.contextKey;

      if (contextKey && contextKey !== prevContextKey) {
        _this2.getCachedResponseFromCacheProvider();
      }
    }, _this2.getCachedResponseFromCacheProvider = function () {
      var _this2$props = _this2.props,
          contextKey = _this2$props.contextKey,
          context = _this2$props.context;
      var cacheProvider = _this2.state.cacheProvider;

      if (cacheProvider && cacheProvider.get) {
        var cacheResponse = cacheProvider.get(contextKey);
        if (cacheResponse) {
          var _cacheProviderData2;

          if (cacheResponse.then && typeof cacheResponse.then === 'function') {
            return cacheResponse.then(function (cacheProviderData) {
              var _cacheProviderData;

              _this2.setState({ cacheProviderData: (_cacheProviderData = {}, _cacheProviderData[contextKey] = cacheResponse, _cacheProviderData), hasLoaded: true });
              context.setContextCache(contextKey, cacheResponse);
            }).catch(function (err) {
              console.error('Error loading data from cacheProvider (contextKey: ' + contextKey + '). Error: ' + err);
              _this2.setState({ hasLoaded: true });
            });
          }
          _this2.setState({ cacheProviderData: (_cacheProviderData2 = {}, _cacheProviderData2[contextKey] = cacheResponse, _cacheProviderData2) });
          context.setContextCache(contextKey, cacheResponse);
        }
      }
      _this2.setState({ hasLoaded: true });
    }, _this2.getCachedResponse = function (_ref) {
      var contextKey = _ref.contextKey;
      var context = _this2.props.context;
      var cacheProviderData = _this2.state.cacheProviderData;

      return cacheProviderData[contextKey] || context.data[contextKey];
    }, _this2.render = function () {
      var _this2$props2 = _this2.props,
          contextKey = _this2$props2.contextKey,
          context = _this2$props2.context,
          children = _this2$props2.children;
      var _this2$state = _this2.state,
          cacheProvider = _this2$state.cacheProvider,
          hasLoaded = _this2$state.hasLoaded;

      return hasLoaded ? children({
        cachedResponse: _this2.getCachedResponse({ contextKey: contextKey }),
        getCachedResponse: _this2.getCachedResponse,
        setResponse: function setResponse(data) {
          return context.setResponse({ contextKey: data.contextKey || contextKey, cacheProvider: cacheProvider, data: data });
        }
      }) : null;
    }, _temp3), _possibleConstructorReturn(_this2, _ret2);
  }

  return LoadsConsumer;
}(React.Component), _class2.defaultProps = {
  cacheProvider: null
}, _class2.getDerivedStateFromProps = function (nextProps, prevState) {
  if (nextProps.contextKey !== prevState.contextKey) {
    return { contextKey: nextProps.contextKey, cacheProviderData: {}, hasLoaded: false };
  }
  return {};
}, _temp4);
LoadsConsumer.propTypes = process.env.NODE_ENV !== "production" ? {
  cacheProvider: PropTypes.shape({
    get: PropTypes.func,
    set: PropTypes.func
  }),
  children: PropTypes.func.isRequired,
  contextKey: PropTypes.string.isRequired,
  context: PropTypes.object.isRequired
} : {};

var _default = (_temp5 = _class3 = function (_React$PureComponent) {
  _inherits(_default, _React$PureComponent);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  return _default;
}(React.PureComponent), _class3.Provider = LoadsProvider, _class3.Consumer = function (props) {
  return React.createElement(
    Consumer,
    null,
    function (context) {
      return React.createElement(LoadsConsumer, _extends({ context: context }, props));
    }
  );
}, _temp5);

export { _default as default };